export const webhooksBasePath = '/settings/integrations/webhooks';
export const helpCenterArticleUrl = 'https://docs.dixa.io/docs/webhooks-guide';
export const readablePaths = {
    settings: 'Settings',
    integration: 'Integration',
};
export const parseEventPayload = (payload) => {
    try {
        return JSON.parse(payload);
    }
    catch (_a) {
        return null;
    }
};
export const mapDeliveryStatuses = (statuses) => statuses.reduce((acc, value) => {
    acc[value.fqn] = value.delivery_status;
    return acc;
}, {});
